<template>
  <div v-if="isI18nLoaded" class="container-fixed offset-bottom-6 offset-top-2">
    <h1>Barring PartnerSelection-Test</h1>
    <VList
      type="partners"
      :items.sync="items"
      :notice="notice"
      @open:exceptions="onOpenExceptions"
      @open:details="onOpenDetails"
      @toggle="onToggle"
      @notice="onNotice"
    />
    <hr />
    <b>Events:</b> {{ lastEvents }}
    <button class="btn btn-default btn-small" @click="lastEvents = []">Reset</button>
    <br />
    <b>Items:</b> {{ items }}
  </div>
</template>

<script>
import VList from '@/components/Barring/PartnerSelection';

export default {
  name: 'TestGrid',

  components: { VList },

  data() {
    return {
      lastEvents: [],
      notice: {
        name: 'Custom Notice',
        type: 'factoring',
        hasExceptions: true,
      },
      items: [
        {
          id: 1,
          type: 'voiceFactoring',
          name: 'MoCoPay GmbH',
          isBarred: false,
          hasExceptions: true,
          scope: 'test',
          hasImage: false,
        },
        {
          id: 2,
          type: 'factoring',
          name: 'Google',
          isBarred: true,
          hasExceptions: false,
          scope: 'test',
          hasImage: false,
        },
        {
          id: 1,
          type: 'voiceFactoring',
          name: 'King.com',
          isBarred: false,
          hasExceptions: true,
          scope: 'test',
          hasImage: false,
        },
        {
          id: 1,
          type: 'globalShortCode',
          name: 'iTunes (Apple) Sarl',
          isBarred: false,
          hasExceptions: false,
          scope: 'test',
          hasImage: false,
        },
        {
          id: 1,
          type: 'factoring',
          name: 'Movie Star Planet',
          isBarred: true,
          hasExceptions: true,
        },
        {
          id: 1,
          type: 'shortCode',
          name: 'Stadtwerke Bonn Verkehrs GmbH',
          isBarred: false,
          hasExceptions: false,
          scope: 'test',
          hasImage: false,
        },
        {
          id: 1,
          type: 'shortCode',
          name: '118',
          isBarred: false,
          hasExceptions: false,
        },
        {
          id: 1,
          type: 'shortCode',
          name: '119',
          isBarred: false,
          hasExceptions: false,
        },
        {
          id: 1,
          type: 'factoring',
          name: 'This is a very long text. Lorem ipsum dolor. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
          isBarred: false,
          hasExceptions: true,
          scope: 'test',
          hasImage: false,
        },
        {
          id: 1,
          type: 'voiceFactoring',
          name: 'BOKU Network Services AG',
          isBarred: false,
          hasExceptions: false,
        },
      ],
    };
  },

  computed: {
    isI18nLoaded() {
      return !!this.$i18n.messages.de.barring;
    },
  },

  methods: {
    onOpenExceptions() {
      this.lastEvents.push('onOpenExceptions');
    },

    onOpenDetails() {
      this.lastEvents.push('onOpenDetails');
    },

    onToggle() {
      this.lastEvents.push('onToggle');
    },

    onNotice() {
      this.lastEvents.push('onNotice');
    },
  },
};
</script>
